import { render } from "./Relation.vue?vue&type=template&id=c0678750&scoped=true"
import script from "./Relation.vue?vue&type=script&lang=js"
export * from "./Relation.vue?vue&type=script&lang=js"

import "./Relation.vue?vue&type=style&index=0&id=c0678750&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0678750"]])

export default __exports__